var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1CC052"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1CC052"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1699 12C6.91448 12 6.72292 11.9042 6.5496 11.6899L4.187 8.77993C4.05473 8.6203 4 8.46978 4 8.31015C4 7.94527 4.2691 7.68073 4.6431 7.68073C4.86659 7.68073 5.02166 7.76283 5.17218 7.94983L7.15165 10.4584L11.0148 4.33751C11.1699 4.09122 11.325 4 11.5804 4C11.9498 4 12.2144 4.25998 12.2144 4.6203C12.2144 4.76169 12.1733 4.90764 12.0639 5.07184L7.79475 11.6762C7.6488 11.8951 7.439 12 7.1699 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.805c0aff3fa7e41e79dc09bb59a67050.svg";
export { ForwardRef as ReactComponent };